import { Injectable } from "@angular/core";
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Observable } from "rxjs";
import { map } from "rxjs/operators";
import { GLOBAL } from "./global";
import { Location } from "../models/location";

@Injectable({
  providedIn: "root",
})
export class CarrieraccountService {
  public url: string;
  public token;
  public headers;

  constructor(private _http: HttpClient) {
    this.url = GLOBAL.url;

    this.headers = new HttpHeaders({
      "Content-Type": "application/x-www-form-urlencoded",
      "X-Requested-With": "XMLHttpRequest",
    });
  }

  listbycompany(
    id?: any,
    page?: any,
    perPage?: any,
    filtros: any[] = []
  ): Observable<any> {
    this.token = JSON.parse(localStorage.getItem("token"));
    let params = `authorization=${this.token}`;
    let headers = new HttpHeaders({
      "Content-Type": "application/x-www-form-urlencoded",
      "X-Requested-With": "XMLHttpRequest",
    });

    page = page ?? 1;
    perPage = perPage ?? 10;

    let queryParams = `?page=${page}&perpage=${perPage}`;
    filtros.forEach((filtro) => {
      if (filtro && filtro.value) {
        queryParams += `&${filtro.key}=${encodeURIComponent(filtro.value)}`;
        if (filtro.key_type) {
          queryParams += `&${filtro.key_type}=${encodeURIComponent(
            filtro.type
          )}`;
        }
      }
    });

    return this._http
      .post<any>(
        `${this.url}/carrieraccount/listbycompany/${id}${queryParams}`,
        params,
        { headers: headers }
      )
      .pipe(map((res: any) => res));
  }

  listAllCarriers(): Observable<any> {
    return this.petition(`${this.url}/carrier/list`);
  }
  create(json: any): Observable<any> {
    return this.petition(`${this.url}/carrieraccount/new`, json);
  }
  getAccounts(id_company = null): Observable<any> {
    return this.petition(
      `${this.url}/carrieraccount/listbycompany/${id_company}`
    );
  }
  update(id: any, json: any): Observable<any> {
    return this.petition(`${this.url}/carrieraccount/edit/${id}`, json);
  }
  detail(id: any): Observable<any> {
    return this.petition(`${this.url}/carrieraccount/detail/${id}`);
  }

  delete(id: any): Observable<any> {
    return this.petition(`${this.url}/carrieraccount/remove/${id}`);
  }

  petition(url, json = null, type = null): Observable<any> {
    this.token = JSON.parse(localStorage.getItem("token"));

    let params, response;
    params = `authorization=${this.token}`;

    if (json != null) {
      json = encodeURIComponent(JSON.stringify(json));
      params = `${params}&json=${json}`;
    }

    if (type != null) {
      params = `${params}&type=${type}`;
    }

    response = this._http
      .post(url, params, { headers: this.headers })
      .pipe(map((res) => res));

    if (response.code === 404) {
      // this.mtds.notifyError('Your session has expired');
      localStorage.clear();
      // this._router.navigate(['/pages/lock']);
    }

    return response;
  }
}
